(function() {
    "use strict";

    angular.module("swurveys.maker").factory("createModal", Handler)

    function Handler(ModalService, swurveyAdminService, utilsService, $location, $timeout) {
        function show(model) {
            return ModalService.showModal({
                templateUrl: "app/modals/swurvey/create/create.html",
                controller: ["$element", "$scope", "close", function($element, $scope, close) {
                        var campaign = this;

                        campaign.options = {
                            name: 'My Swurvey',
                            type: undefined, // free or premium
                            model: model
                        }

                        var jmc = CSSJSON.toJSON(model.styles.join(" ")).children;

                        // TODO: Extract style if oldModel exist
                        campaign.style = {
                            background: jmc[".viewer"],
                            cards: jmc[".card-top-bg"],
                            text: jmc[".card-text"]
                        }

                        // campaign.state = "type";
                        campaign.state = "setup";

                        campaign.stateHeaders = {
                            "type": "Choose Your Campaign Type",
                            "setup": "Set Up Your Swurvey"
                        };

                        campaign.setType = function(type) {

                            campaign.options.type = type;

                            campaign.state = "setup";
                        };

                        campaign.submitModel = function() {
                            $scope.createLoadingSpinner = true;
                            if (!campaign.options.name) {
                                return;
                            }

                            var primaryColor = jmc[".viewer"].attributes['background-color'];
                            var secondaryColor = jmc[".card-top-bg"].attributes['background-color'];
                            var accentColor = jmc[".card-text"].attributes['color'];

                            // Text & Chevrons
                            jmc[".card-text b"].attributes['color'] = accentColor; // bolded card text
                            jmc[".hint-text"].attributes['color'] = accentColor; // answer text
                            jmc[".counter-wrapper b"].attributes['color'] = accentColor; // counter
                            jmc[".viewer .fa"].attributes['color'] = primaryColor; // chevrons

                            // Slider
                            jmc[".slider-control"].attributes['background-color'] = primaryColor; // slider background
                            jmc[".slider-control"].attributes['border-color'] = primaryColor; // slider border
                            jmc[".ui-slider-horizontal .ui-slider-handle"].attributes['background-color'] = accentColor; // slider handle background
                            jmc[".ui-slider-horizontal .ui-slider-handle"].attributes['border-color'] = accentColor; // slider handle border

                            // WOT
                            jmc["#WOTPercentage"].attributes['color'] = secondaryColor; // WOT percentage text
                            jmc[".WOTMainText"].attributes['color'] = secondaryColor; // WOT main text
                            jmc[".WOTText"].attributes['color'] = accentColor; // WOT text
                            jmc[".socialcircle"].attributes['background-color'] = accentColor; // Share icons

                            // Action
                            jmc[".dataLink"].attributes['color'] = accentColor; // 'See All Results' link
                            jmc[".custom-link"].attributes['color'] = accentColor; // Custom action link

                            // Apply and parse the chosen color here and put it into the model
                            var css = utilsService.CSSArrayFromJSONChildren(jmc);

                            campaign.options.model.styles = css;

                            swurveyAdminService.createSwurvey(campaign.options.name, campaign.options.model,
                                function (err, id) {
                                    if (id) {
                                        $timeout(function() {
                                            $scope.createLoadingSpinner = false;
                                            $location.path("/e/" + id);
                                        });
                                    }
                                        else {
                                            console.log('Error: ' + err);
                                            $scope.createSwurveyError = "Whoops!  While trying to create your swurvey we got a " + err + " error.  If you keep having this problem, write this error down and let our admins know!";
                                            $scope.createLoadingSpinner = false;
                                        }
                                }
                            );

                        };
                       campaign.close = function() {
                           close(null, 500);
                       };
                    }
                ],
                controllerAs: "campaign"
            });
        }

        return {
        show: show,
        };
    }
}());
